<template>
  <div>
    <el-dialog :visible.sync="openCardDialog" width="40%" >
      <el-container>
        <img src="../../../assets/image/login.jpg" style="width: 50%;" alt="">
        <el-form :model="loginForm" :rules="Rules" ref="User" style="margin: 0 auto">
          <h3 style="text-align: center">登 录</h3>
          <el-form-item prop="phoneNum">
            <el-input v-model="loginForm.phoneNum" placeholder="请输入手机号"  @keyup.enter.native="handleEnterKey"></el-input>
          </el-form-item>
          <div id="slideBar"></div>
          <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" auto-complete="new-password"
                      placeholder="请输入密码"  @keyup.enter.native="handleEnterKey"></el-input>
          </el-form-item>
          <!--登陆注册-->
          <el-form-item>
            <el-button style="width: 200px" type="primary" @click="login()" >登 录</el-button>
          </el-form-item>
          <!--忘记密码-->
          <el-form-item>
            <el-button @click="registerShow()" type="primary" plain>注册账号</el-button>
            <el-button @click="forgetPwd()" type="primary" plain>忘记密码</el-button>
<!--            <el-button @click="forgetPasswdShow = true" type="primary" plain>忘记密码</el-button>-->
          </el-form-item>
          <el-form-item>
              <p style="float: left;margin-top: 0" @click="$router.push('/admin')">后台管理</p>
            </el-form-item>
        </el-form>
      </el-container>

      <!--  内嵌视图  -->
      <!--  注册  -->

<!--      <el-dialog title="注 册" :visible.sync="registerShow" center :append-to-body='true' :lock-scroll="false"-->
<!--                 width="30%" center>-->
<!--        <Register></Register>-->
<!--      </el-dialog>-->
        <!--  修改密码  -->
<!--      <el-dialog title="修改密码" :visible.sync="forgetPasswdShow" center :append-to-body='true' :lock-scroll="false"-->
<!--                 width="30%" center>-->
<!--        <ForgetPasswd></ForgetPasswd>-->
<!--      </el-dialog>-->
    </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui"
//import Register from "./Register";
import ForgetPasswd from "./ForgetPasswd";

export default {
  name: "Login",
  components: {
//    Register,
    ForgetPasswd
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    openCardDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
      }
    },

  },
  data() {
    return {
//      registerShow: false,
      forgetPasswdShow: false,
      Rules: '',
      loginForm: {
        phoneNum: '',
        password: '',
      }
    }
  },
  methods: {
    async login() {
      const {data: res} = await this.$http.post("/login", this.loginForm)
      if (res.code === 1) {
        Message.success('登陆成功')
        sessionStorage.setItem('token', res.data)
        location.reload()
      } else {
        Message.error(res.data)
      }
    },
    registerShow(){
      Message.success('注册请联系客服老师！')
    },
    forgetPwd(){
      Message.success('忘记密码请联系客服老师！')
    },
    //处理Enter键的逻辑
    handleEnterKey() {
      // 处理Enter键的逻辑
      console.log('处理Enter键的逻辑11')
       //调用方法
      this.login();
    },
  }
}
</script>

<style scoped>
p {
  color: #409EFF;
}
.el-button--primary {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #FFF;
}
.el-button--primary:hover {
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
}
</style>
